var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0175 16.4759H11.4118C10.6321 16.4759 10 17.1771 10 18.0421V21.9577C10 22.8227 10.6321 23.524 11.4118 23.524H14.0175C14.1595 23.524 14.2981 23.5715 14.4153 23.6602L19.7931 27.7278C20.4373 28.215 21.3156 28.0306 21.7548 27.3158C21.9145 27.0558 22 26.7484 22 26.4337V13.5662C22 12.7012 21.3679 12 20.5882 12C20.3045 12 20.0275 12.0948 19.7931 12.2721L14.4153 16.3396C14.2981 16.4284 14.1595 16.4758 14.0175 16.4759V16.4759Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3872 16.2284C24.0731 15.9239 23.5496 15.9239 23.2356 16.2284C22.9215 16.533 22.9215 17.0405 23.2356 17.3451C24.748 18.8114 24.748 21.1915 23.2356 22.6579C22.9215 22.9624 22.9215 23.47 23.2356 23.7744C23.3983 23.9323 23.6078 24 23.8055 24C24.0033 24 24.2245 23.9212 24.3756 23.7631C26.5395 21.699 26.5395 18.3151 24.3872 16.2284Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2513 14.2356C24.9162 14.5517 24.9162 15.0784 25.2513 15.3945C26.5547 16.6236 27.2748 18.2507 27.2748 19.9949C27.2748 21.7391 26.5547 23.3662 25.2513 24.5953C24.9162 24.9114 24.9162 25.4381 25.2513 25.7542C25.4251 25.9179 25.6485 26 25.8595 26C26.083 26 26.3064 25.9181 26.4678 25.7659C28.0939 24.2324 29 22.1839 29 20.0066C29 17.8293 28.1062 15.7925 26.4678 14.2473C26.145 13.9195 25.5989 13.9195 25.2513 14.2356Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.06aba2cf9231e75922e59e885321f097.svg";
export { ForwardRef as ReactComponent };